import { render, staticRenderFns } from "./estadisticas.vue?vue&type=template&id=e460c17c&scoped=true&"
import script from "./estadisticas.vue?vue&type=script&lang=js&"
export * from "./estadisticas.vue?vue&type=script&lang=js&"
import style0 from "./estadisticas.vue?vue&type=style&index=0&id=e460c17c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e460c17c",
  null
  
)

export default component.exports